import { environment } from "../../../../environments/environment";

export const Pluviometers: any[] = [
  {
    name: 'Obras públicas',
    slug: 'obrasp',
    temperature: 102,
    precipitation: 101,
    relativeHumidity: 106,
    location: {
      address: 'C. Santivañez y C. Avaroa',
      coords: {
        lat: '-17.39549727525316',
        lng: '-66.16624115732476'
      }
    },
    baseLink: "https://proxy-server-pls5.onrender.com/proxy",
    link: `${environment.baseLink}/pluviometer/obrasp`
  },
  {
    name: 'Hospital del Norte',
    slug: 'hospitalnorte',
    temperature: '',
    precipitation: 10182,
    relativeHumidity: '',
    location: {
      address: 'Av. Los Angeles',
      coords: {
        lat: '-17.34884490153279',
        lng: '-66.17482251627352'
      }
    },
    baseLink: "https://proxy-server-pls5.onrender.com/proxy",
    link: `${environment.baseLink}/pluviometer/hospitalnorte`
  },
  {
    name: 'Edf. CREMPLA',
    slug: 'crempla',
    temperature: '',
    precipitation: 10060,
    relativeHumidity: '',
    location: {
      address: 'Av. Circuito Bolivia',
      coords: {
        lat: '-17.40002933866242',
        lng: '-66.14052731860916'
      }
    },
    baseLink: "https://proxy-server-pls5.onrender.com/proxy",
    link: `${environment.baseLink}/pluviometer/crempla`
  }
]